import React, { useState } from "react";
import { useSelector } from 'react-redux';
import './ChangePassword.css'
import { useNavigate } from "react-router-dom";
import { IoIosEye } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";
import { CommonBaseURl } from "../../../Commonprovider/CommonProvider";

export const ChangePassword = ({ setChangePasswordpopup }) => {
  const [BaseURL] = useState(CommonBaseURl);
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState()
  const [strength, setStrength] = useState("");
  const [errors, setErrors] = useState({});
  const [viewoldPassword, setViewOldPassword] = useState(false)
  const [viewnewPassword, setViewNewPassword] = useState(false)
  const [viewConfirmPassword, setViewConfirmPassword] = useState(false)
  const Token = useSelector(state => state.Authenticationapi.token)
  const UserDetails = useSelector((state) => state.LoginUserDetails.data)
  let id = UserDetails && UserDetails.length != 0 ? UserDetails[0].UserId || JSON.parse(UserDetails)[0].UserId : ''
  const navigate = useNavigate()

  const handleChangePassword = async () => {
    const newErrors = {};
    if (!oldPassword) {
      newErrors.oldPassword = "Existing password required!";
    }
    if (!newPassword) {
      newErrors.newPassword = "New password required!";
    }
    if (!confirmNewPassword) {
      newErrors.confirmNewPassword = "Confirm Password is required!";
    } else {
      if (strength != "Strong") {
        return alert("Password should be strong")
      }
      if (newPassword === confirmNewPassword) {
        if (Token != null) {
          let params = {
            "test": "Abc",
            "userid": id,
            "oldpass": oldPassword,
            "newpass": newPassword,
            "test2": "Abc"
          };
          const response = await fetch(`${BaseURL}changepass`, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: "Bearer " + Token.access_token,
            },
            body: new URLSearchParams(params).toString(),
          })
          let data = await response.json();
          let result = data;
          let len = result.length
          alert(result.slice(12, len - 3))
          if (result.slice(12, len - 3) == 'Password changed successfully') {
            setChangePasswordpopup(false)
            navigate('/Landing')
          }
        }
      } else {
        newErrors.confirmNewPassword = "Confirm password is not same as password";
      }
    }
    setErrors(newErrors)
  }

  const checkStrength = (pwd) => {
    if (pwd.length === 0) {
      setStrength("");
    } else if (pwd.length < 8 || pwd.length > 15 || !/[A-Z]/.test(pwd) || !/[a-z]/.test(pwd) || !/[0-9]/.test(pwd) || !/[!@#$%^&*]/.test(pwd)) {
      setStrength("Weak");
    } else if (pwd.length >= 8 && pwd.length <= 15) {
      setStrength("Strong");
    }
  };

  const getStrengthStyle = () => {
    switch (strength) {
      case "Weak":
        return { backgroundColor: "#ff4d4d", width: "50%" };
      case "Strong":
        return { backgroundColor: "#4caf50", width: "100%" };
      default:
        return { backgroundColor: "#ccc", width: "0%" };
    }
  }

  const handleInputChange = (e, field) => {
    const { value } = e.target;
    if (field === 'oldPassword') {
      setOldPassword(value);
    } else if (field === 'newPassword') {
      setNewPassword(value);
      checkStrength(value);
    } else if (field === 'confirmNewPassword') {
      setConfirmNewPassword(value);
    }

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[field];
      return newErrors;
    });
  };

  return (
    <>
      <div
        className="modal fade show change-password-container"
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog"
      // ref={modalRef}
      >
        <div className="common-div" onClick={() => setChangePasswordpopup(false)}></div>
        <div className="modal-dialog modal-400">
          <div className="modal-content">
            <div className="landing-box-head">
              <h5>Change Password</h5>
            </div>
            <div className="modal-body common-scroller popup-form change-password">
              <div className="password-container">
                {viewoldPassword ? (<span><IoIosEye onClick={() => setViewOldPassword(!viewoldPassword)} /></span>) : (<span><IoIosEyeOff onClick={() => setViewOldPassword(!viewoldPassword)} /></span>)}
                <input
                  type={`${viewoldPassword ? "text" : "password"}`}
                  className={errors.oldPassword ? "error" : ""}
                  placeholder="Enter Existing Password"
                  value={oldPassword}
                  onChange={(e) => handleInputChange(e, 'oldPassword')}
                  name="oldPassword"
                  maxLength={15}
                />
                {errors.oldPassword && (
                  <div className="error-text">{errors.oldPassword}</div>
                )}
              </div>
              <div className="password-container">
                {viewnewPassword ? (<span><IoIosEye onClick={() => setViewNewPassword(!viewnewPassword)} /></span>) : (<span><IoIosEyeOff onClick={() => setViewNewPassword(!viewnewPassword)} /></span>)}
                <input
                  type={`${viewnewPassword ? "text" : "password"}`}
                  className={errors.newPassword ? "error" : ""}
                  placeholder="Enter New Password"
                  value={newPassword}
                  onChange={(e) => handleInputChange(e, 'newPassword')}
                  name="newPassword"
                  maxLength={15}
                />
                {errors.newPassword && (
                  <div className="error-text">{errors.newPassword}</div>
                )}
                {(newPassword) && (<div className="passwordloading">
                  <div className="childpassword" style={{ ...getStrengthStyle() }}></div>
                </div>)}
              </div>
              <div className="password-container">
                {viewConfirmPassword ? (<span><IoIosEye onClick={() => setViewConfirmPassword(!viewConfirmPassword)} /></span>) : (<span><IoIosEyeOff onClick={() => setViewConfirmPassword(!viewConfirmPassword)} /></span>)}
                <input
                  type={`${viewConfirmPassword ? "text" : "password"}`}
                  className={errors.confirmNewPassword ? "error" : ""}
                  placeholder="Enter Confirm Password"
                  value={confirmNewPassword}
                  onChange={(e) => handleInputChange(e, 'confirmNewPassword')}
                  name="confirmNewPassword"
                  maxLength={15}
                />
                {errors.confirmNewPassword && (
                  <div className="error-text">{errors.confirmNewPassword}</div>
                )}
              </div>
              <p className="note"><span>* </span> Password should be 8-15 characters in length and should be mixture of upper,lower,number and special character.</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="bttn-close"
                onClick={() => setChangePasswordpopup(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="bttn"
                onClick={() => handleChangePassword()}
              >
                submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
